import React, { Component } from "react";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import { withTranslation } from "react-i18next";

class ReviewTradesToggle extends Component {
  render() {
    const { t, tradeId, tradeState, handleApprove, handleReject } = this.props;

    return (
      <ButtonGroup
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        className="btn-group-toggle"
        data-toggle="buttons"
        aria-label="Basic example"
      >
        <Button
          className="btn-sm"
          onClick={() => handleReject(tradeId)}
          disabled={tradeState === "Rejected"}
          variant={
            tradeState === "Rejected"
              ? "danger"
              : tradeState === "Submitted"
              ? "secondary"
              : " dark"
          }
        >
          {tradeState === "Rejected" ? t("Rejected") : t("Reject")}
        </Button>
        <Button
          className="btn-sm"
          onClick={() => handleApprove(tradeId)}
          disabled={tradeState === "Approved"}
          variant={
            tradeState === "Approved"
              ? "success"
              : tradeState === "Submitted"
              ? "secondary"
              : " dark"
          }
        >
          {tradeState === "Approved" ? t("Approved") : t("Approve")}
        </Button>
      </ButtonGroup>
    );
  }
}

export default withTranslation(["marketdata"])(ReviewTradesToggle);
